/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_DurationInputs */

const vi_trip_duration = /** @type {(inputs: Trip_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời lượng`)
};

/**

* @param {Trip_DurationInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_duration = /** @type {((inputs?: Trip_DurationInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_DurationInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_duration(inputs)
});